import { AjaxHelper } from '@samc/common';
import { PageListDataSource } from './BaseDataSources';
import { ITaskTypeTemplate } from '../Interfaces';

export class TaskTemplateSource extends PageListDataSource<ITaskTypeTemplate> {
  /**
   * @param {boolean} isDeal - An optional parameter for filtering by deal flag.
   */
  public constructor(isDeal?: boolean) {
    super('/componentapi/transaction/templates', { isDeal }, 100);
  }

  /**
   * Loads a single template with taskTypeTemplateItems (list endpoint may omit items).
   */
  public async getById(id: number): Promise<ITaskTypeTemplate> {
    const helper = new AjaxHelper(`/componentapi/transaction/templates/${id}`, '', '', null);
    return await helper.getData<ITaskTypeTemplate>('');
  }
}

